import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import {
  ApiCompensationChangeReason,
  ApiCompensationChangeReasonPayload,
} from "@/types/compensation-change-reason.types.ts";

export const apiCompensationChangeReasons = {
  getAll: () => {
    return api.get<ApiCompensationChangeReason[]>("/api/v1/compensation-change-reasons");
  },
  create: (payload: ApiCompensationChangeReasonPayload) => {
    return api.post<ApiCompensationChangeReason>("/api/v1/compensation-change-reasons", payload);
  },
  update: (id: number, payload: ApiCompensationChangeReasonPayload) => {
    return api.put<ApiCompensationChangeReason>(
      `/api/v1/compensation-change-reasons/${id}`,
      payload
    );
  },
  delete: (id: number) => {
    return api.delete<ApiOperationResult>(`/api/v1/compensation-change-reasons/${id}`);
  },
};
